import { useTahun } from "@/hooks/useTahun";
import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";

const getListDataUktPendaftarLulusRekap = async (
  idsRefJalurJenis: string,
  idsJenisUktParams: string,
  tahunParams: string,
) => {
  const response = await api.get(`/data-ukt-pendaftar-lulus/rekap`, {
    params: {
      ids_ref_jalur_jenis: idsRefJalurJenis,
      ids_jenis_ukt: idsJenisUktParams,
      tahun: tahunParams,
    },
    withCredentials: true,
  });

  return response.data?.data;
};

export default function Rekap() {
  const [searchParams] = useSearchParams();
  const idsRefJalurJenisParams = searchParams.get("ids_ref_jalur_jenis");
  const idsJenisUktParams = searchParams.get("ids_jenis_ukt");

  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: [
      "listDataUktPendaftarLulusRekap",
      idsRefJalurJenisParams,
      idsJenisUktParams,
      selectedTahun?.value,
    ],
    queryFn: () =>
      getListDataUktPendaftarLulusRekap(
        idsRefJalurJenisParams as string,
        idsJenisUktParams as string,
        String(selectedTahun?.value),
      ),
  });

  return (
    <div>
      <DataTable data={data || []} isPending={isPending} columns={columns} />
    </div>
  );
}
